import { ISchemaError } from "../interfaces/ISchemaError/ISchemaError";
import { z } from "zod";

export const tenantIdSchema = z
  .string({ invalid_type_error: ISchemaError.TENANT_ID_INVALID_TYPE })
  .uuid({ message: ISchemaError.INVALID_GUID })
  .min(1, { message: ISchemaError.NO_TENANT_ID })
  .max(36, { message: ISchemaError.TENANT_ID_TOO_LONG });
